import {GridWidgetTask} from './grid-widget-task';
import {GridWidgetDataField} from './grid-widget-data-field';
import {Counter} from '../../interfaces/counter1';
declare let isNaN;

let compare = (item1, item2) => {
  if (item1 > item2) {
    return 1;
  } else if (item1 < item2) {
    return -1;
  } else {
    return 0;
  }
};

export class CounterTask extends GridWidgetTask implements Counter {

  priority = 150;
  dataField: GridWidgetDataField;
  taskCompleteCallback: () => void;
  itemCounts: Array<{label: string, value: number, link: string}>;
  reverseSort: boolean;
  //Map<ResolvedValue: boolean>
  valuesOn: {[value: string]: boolean} = {};
  name = 'counter-task';

  constructor(dataField: GridWidgetDataField, reverseSort = false, priority?: number) {
    super();
    if (priority != null) {
      this.priority = priority;
    }
    this.dataField = dataField;

    this.reverseSort = reverseSort;
  }

  getPriority(): number {
    return this.priority;
  }

  countRow(dataRow: any, itemCounts: {[label: string]: number}): void {
    let dataAsString = String(this.dataField.resolve(dataRow));
    if (dataAsString == null || dataAsString === '') {
      dataAsString = 'none';
    }
    if (itemCounts.hasOwnProperty(dataAsString)) {
      itemCounts[dataAsString]++;
    } else {
      itemCounts[dataAsString] = 1;
    }
  }

  updateSelected(itemValue: string): void {
    this.valuesOn[itemValue] = !this.valuesOn[itemValue];

    this.result.forEach((dataRow) => {
      dataRow.selected = this.valuesOn[this.dataField.resolve(dataRow)];
    });
  }

  getDataField(): GridWidgetDataField {
    return this.dataField;
  }

  setUpdateDataCallback(updateDataCallback: () => void): void {
    this.taskCompleteCallback = updateDataCallback;
  }

  getItemCounts(): Array<{label: string, value: number, link: string}> {
    return this.itemCounts;
  }

  countItems(dataRows: Array<any>): void {
    let arrayForm: Array<{
      label: string,
      value: number,
      link: string}> = [];

    let itemCounts: {[label: string]: number} = {};

    dataRows.forEach((dataRow) => {
      this.countRow(dataRow, itemCounts);
    });

    // tslint:disable-next-line:forin
    for (let itemName in itemCounts) {
      let count: number = itemCounts[itemName];
      arrayForm.push({
        label: itemName,
        value: count,
        link: 'JavaScript: var e = new Event("CountSelected");' +
        'e.itemValue="' + itemName + '";' +
        'e.dataFieldId="' + this.dataField.id + '";' +
        'document.dispatchEvent(e);'
      });
    }

    let getItemVal = (item: {label: string, value: number, link: string}): any => {
      if (!this.reverseSort) {
        return item.value;
      } else {
        if (item.label != null && !isNaN(item.label)) {
          return parseInt(item.label);
        } else {
          return item.label;
        }
      }
    };

    arrayForm.sort((item1, item2) => {
      return compare(getItemVal(item1), getItemVal(item2));
    });

    // arrayForm = _.sortBy(arrayForm, (item: {label: string, value: number, link: string}) => {
    //     if(!this.reverseSort) {
    //         return item.value
    //     }
    //     else {
    //         if(item.label != null && !isNaN(item.label)) {
    //             return parseInt(item.label);
    //         }
    //         else {
    //             return item.label;
    //         }
    //     }
    // });

    this.itemCounts = arrayForm;
    if (this.taskCompleteCallback != null) {
      this.taskCompleteCallback();
    }
  }

  run(dataRows: Array<any>): Array<any> {
    this.countItems(dataRows);
    return dataRows;
  }
}
